import useSWR, { type SWRConfiguration } from 'swr';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import type OrgSummaryMetrics from '@/types/api/OrgSummaryMetrics';
import { fetcher } from '@/utils/services';

const useOrgSummary = (swrOptions?: SWRConfiguration) => {
  const ownerOrgId = useOwnerOrgId();
  return useSWR<OrgSummaryMetrics>(
    `reporting/${ownerOrgId}/org-summary-metrics`,
    fetcher,
    swrOptions,
  );
};

export default useOrgSummary;
